var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { deleteDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { PopupButton, PopupWindow } from "@/06-shared/ui/popups";
import styles from "./index.module.css";
export const DeleteTreeNodePopup = ({ document, onProcessFinished = () => { }, }) => {
    const [isShown, setShown] = useState(false);
    const showError = useNotifyError();
    const removeDocument = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield deleteDocument({ docId: document.id });
            setShown(false);
            onProcessFinished();
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: styles.actionButton, type: "button", onClick: (event) => {
                    event.stopPropagation();
                    setShown(true);
                } }, { children: "[del]" })), isShown ? (_jsxs(PopupWindow, Object.assign({ name: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", onClose: () => setShown(false) }, { children: [_jsxs("p", Object.assign({ className: styles.confirmText }, { children: ["\u0423\u0434\u0430\u043B\u0438\u0442\u044C ", document.type === "directory" ? "директорию" : "файл", " \"", document.title, "\"?"] })), _jsx("p", Object.assign({ className: styles.confirmHint }, { children: document.type === "directory" ? "Содержимое директории тоже будет удалено" : "Это действие нельзя отменить" })), _jsx(PopupButton, { name: "[Cancel]", onClick: () => setShown(false) }), _jsx(PopupButton, { name: "[Delete]", onClick: removeDocument })] }))) : null] }));
};
